import React from 'react';

import PortfolioContainer from '@totem/components/services/optimize/v2/dashboard/PortfolioContainer';
import PortfolioPanel from '@totem/components/services/optimize/v2/dashboard/PortfolioPanel';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';

const PortfolioDashboardPage = () => (
  <ContentLayout>
    <PortfolioContainer>
      <IBCard isCovered title="Optimize — Portfolio Dashboard">
        <PortfolioPanel />
      </IBCard>
    </PortfolioContainer>
  </ContentLayout>
);

export default PortfolioDashboardPage;
